import { Component, OnInit } from '@angular/core';
import { AddressBookTableComponent } from '../address-book-table/address-book-table.component';
import { AddressBookTableFilterComponent } from '../address-book-table-filter/address-book-table-filter.component';

@Component({
    selector: 'app-address-books-page',
    templateUrl: './address-books-page.component.html',
    styleUrls: ['./address-books-page.component.scss'],
    imports: [AddressBookTableFilterComponent, AddressBookTableComponent]
})
export class AddressBooksPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
